import { AutoMap } from '@automapper/classes';
import {
  IsArray, IsBoolean,
  IsDate,
  IsDefined, IsLatitude, IsLongitude,
  IsNotEmpty, IsNumber, IsObject,
  IsOptional, IsPostalCode,
  IsString,
  IsTimeZone,
  IsUUID
} from 'class-validator';
import { StoreDto } from './store.model';

export class SiteDto {
  @AutoMap()
  @IsUUID()
  @IsDefined()
  @IsNotEmpty()
  id: string;

  @IsUUID()
  @IsDefined()
  @IsNotEmpty()
  parentId: string;

  @IsUUID()
  @IsDefined()
  @IsNotEmpty()
  deviceId: string;

  @IsString()
  @IsDefined()
  @IsNotEmpty()
  displayLabel: string;

  @IsString()
  @IsDefined()
  @IsNotEmpty()
  sid: string;

  @IsTimeZone()
  @IsDefined()
  @IsNotEmpty()
  timezone: string;

  @IsBoolean()
  commissioned: boolean;

  @IsLatitude()
  latitude: number;

  @IsLongitude()
  longitude: number;

  @IsString()
  machineName: string;

  @IsPostalCode()
  postalCode: string;

  @IsString()
  address: string;

  @IsString()
  @IsOptional()
  controlMode?: string;

  @IsDate()
  @IsDefined()
  lastUpdatedDate: Date;

  @IsString()
  @IsOptional()
  supplyAfter?: string;

  @IsString()
  @IsOptional()
  deliveryAfter?: string;

  @IsString()
  @IsOptional()
  deliveryBefore?: string;

  @IsString()
  @IsOptional()
  supplyBefore?: string;

  @IsString()
  @IsOptional()
  utility?: string;

  @IsString()
  @IsOptional()
  registrationId?: string;

  @IsString()
  @IsOptional()
  tags?: string;

  @IsNumber()
  @IsOptional()
  vppSiteConfigurationFactor?: number;

  @IsBoolean()
  online: boolean;

  @IsNumber()
  soc: number;

  @IsNumber()
  power: number;

  @IsOptional()
  @IsArray()
  stores?: StoreDto[];

  @IsOptional()
  @IsObject()
  configurations?: Record<string, string>;
}
